import { useSelector } from 'react-redux';

import { selectors as partnerSelectors } from 'redux/partner';
import { featureAdoptionService } from 'shared/services/feature-adoption';

import { FeatureAdoptionTypes } from 'components/main-layout/domain/models';

import type { AdoptionData } from 'components/main-layout/domain/models';

export function mainLayoutAdoptionService() {
  const _STORAGE_ITEM_NAME = 'main_layout_adoption';
  const isFastFromOCC = useSelector(partnerSelectors.selectIsFastFromOCC);
  const {
    MAX_VIEWS,
    getStoredData,
    hasDayElapsed,
    initialAdoptionValue,
    updateStoredData,
  } = featureAdoptionService<FeatureAdoptionTypes>({
    storageItemName: _STORAGE_ITEM_NAME,
  });

  const addInitialStoredData = () => {
    const initialValues: Record<FeatureAdoptionTypes, AdoptionData> = {
      [FeatureAdoptionTypes.highDemandBtn]: initialAdoptionValue(
        FeatureAdoptionTypes.highDemandBtn,
      ),
      [FeatureAdoptionTypes.saturatedZoneHDB]: initialAdoptionValue(
        FeatureAdoptionTypes.saturatedZoneHDB,
      ),
    };
    const storeData: AdoptionData[] = [
      initialValues[FeatureAdoptionTypes.highDemandBtn],
      ...(isFastFromOCC
        ? [initialValues[FeatureAdoptionTypes.saturatedZoneHDB]]
        : []),
    ];
    if (storeData.length > 0) {
      localStorage.setItem(_STORAGE_ITEM_NAME, JSON.stringify(storeData));
    }
  };

  const addStoredData = (type: FeatureAdoptionTypes) => {
    const storeData = getStoredData();
    const initialValues: Record<
      FeatureAdoptionTypes,
      ReturnType<typeof initialAdoptionValue>
    > = {
      [FeatureAdoptionTypes.highDemandBtn]: initialAdoptionValue(
        FeatureAdoptionTypes.highDemandBtn,
      ),
      // TODO: remove this after 3 months, launch date 24-11-25
      [FeatureAdoptionTypes.saturatedZoneHDB]: initialAdoptionValue(
        FeatureAdoptionTypes.saturatedZoneHDB,
      ),
    };
    const valueToAdd = initialValues[type];
    if (valueToAdd !== undefined) {
      storeData.push(valueToAdd);
    }
    localStorage.setItem(_STORAGE_ITEM_NAME, JSON.stringify(storeData));
  };

  return {
    getStoredData,
    updateStoredData,
    hasDayElapsed,
    addInitialStoredData,
    addStoredData,
    MAX_VIEWS,
    isFastFromOCC,
  };
}
